import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material';
import ReplayIcon from '@mui/icons-material/Replay';
import { GridActionsCellItem } from '@mui/x-data-grid-premium';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import toast from 'features/toast';

interface ConfirmationRestoreTableDialogProps {
  label?: string;
  message?: string;
  onConfirm: () => void | Promise<void>;
  // Needed because `getActions` returns an array of elements and this
  // codebase's TS/ESLint setup requires an explicit `key` attribute.
  key?: any;
}

export default function ConfirmationGridRestoreDialog(params: ConfirmationRestoreTableDialogProps) {
  const { label, message, onConfirm } = params;
  const { t } = useTranslation();

  const [openDialog, setOpenDialog] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleConfirm = async () => {
    try {
      setIsSubmitting(true);
      await onConfirm();
      setOpenDialog(false);
    } catch (e: any) {
      // Make failures visible; otherwise it looks like "nothing happens".
      const detail =
        e?.response?.data?.error ||
        e?.response?.data?.detail ||
        e?.message ||
        'Errore durante il ripristino';
      toast.error(String(detail));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <GridActionsCellItem
        key={990}
        label={label || 'Ripristina'}
        icon={<ReplayIcon />}
        onClick={() => setOpenDialog(true)}
      />
      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>Conferma ripristino</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {message ?? "Vuoi ripristinare l'oggetto selezionato?"}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary" disabled={isSubmitting}>
            {t('actions.cancel')}
          </Button>
          <Button onClick={handleConfirm} color="primary" autoFocus disabled={isSubmitting}>
            {t('actions.confirm')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
